/* eslint-disable */
import React, { useState, useEffect } from 'react';
import {
  Grid,
  Paper,
  TextField,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Switch,
  Box,
  InputAdornment,
  FormControlLabel,
  Checkbox,
  IconButton,
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import AddShoppingCartIcon from '@mui/icons-material/AddShoppingCart';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import dayjs from 'dayjs';
import axios from 'axios';
import { getStorage } from '../utils/functions/localstorage';
import TableStoreManagement from '../components/TableStoreManagement';
import BankAccountPopup from '../views/BankAccountPopup';
import AddIcon from '@mui/icons-material/Add'; // Import ไอคอน Add
import DeleteIcon from '@mui/icons-material/Delete';
import FormHelperText from '@mui/material/FormHelperText';
import Loading from '../components/Loading';
import { values } from 'lodash';
import Swal from 'sweetalert2';

function StoreManagementSuperAdmin() {
  const paymentOptions = [
    { label: '-', value: '-' },
    { label: 'QR Code ( OPS )', value: 'QR Code' },
    { label: 'QR Code ( New OPS )', value: 'QR Code - SCB' },
    // { label: 'QR CIMB', value: 'QR Code - CIMB' },
    { label: 'QR Credit', value: 'QR Code Credit Card' },
    // { label: 'QR All In One', value: 'QR Code PromptPay Credit Card' },
    { label: 'Credit Card', value: 'Credit Card' },
    { label: 'Credit Card Foreign', value: 'Credit Card Foreign' },
    { label: 'Installment - SCB', value: 'Installment - SCB' },
    { label: 'Installment - KTC', value: 'Installment - KTC' },
    { label: 'Upload', value: 'Upload' },
    { label: 'Mobile Banking', value: 'Mobile Banking' },
    { label: 'Wallet', value: 'Wallet' },
    { label: 'Recurring', value: 'Recurring' },
    { label: 'Visual Account', value: 'Visual Account' },
  ];
  const feeType = [
    { label: 'None', value: 'none' },
    { label: 'Fix Rate', value: 'fixed' },
    { label: 'Percentage', value: 'percentage' },
  ];

  const revenueType = [
    { label: 'None', value: 'inactive' },
    { label: 'Active', value: 'active' },
  ];

  const [errors, setErrors] = useState({
    name: '',
    apiKey: '',
    secretKey: '',
    taxId: '',
    pay_type: [''],
    pay_type_key: [''],
  });

  const [isstoreManagementSuperAdmin, setISstoreManagementSuperAdmin] =
    useState([]);

  const [searchText, setSearchText] = useState('');

  const [pagination, setPagination] = useState({
    currPage: 1,
    size: 10,
    lastPage: 1,
    total: 0,
  });
  const [isLoading, setIsLoading] = useState(false);
  const [selectedMerchants, setSelectedMerchants] = useState('');

  const [openAddStoreDialog, setOpenAddStoreDialog] = useState(false);

  const [logoFile, setLogoFile] = useState(null);
  const [logoPreview, setLogoPreview] = useState('');

  const handleImageUpload = (event) => {
    const file = event.target.files[0];
    setLogoFile(file);
    setLogoPreview(URL.createObjectURL(file));
  };

  const [store, setStore] = useState({
    name: '',
    apiKey: '',
    pay_type: [''], // Array ขนาด 5 ตำแหน่ง
    pay_type_key: [''],
    fee_type: ['none'],
    fee: ['0'],
    eTaxEnabled: 'false',
    taxId: '',
    secretKey: '',
    revenue: 'inactive',
    recipient_id: [''],
  });

  // const handleStoreChange = (e) => {
  //   const { name, value, checked, type } = e.target;
  //   setStore((prevStore) => ({
  //     ...prevStore,
  //     [name]: type === 'checkbox' ? checked : value,
  //   }));
  // };

  // const handlePaymentChange = (event) => {
  //   const value = event.target.value;
  //   setSelectedPayment(value);
  //   if (value === 'Upload') {
  //     setOpenBankAccountPopup(true);
  //   } else {
  //     setOpenBankAccountPopup(false);
  //   }
  // };

  // BankAccountPopup
  const [bankAccountData, setBankAccountData] = useState('');
  const handleSaveBankAccount = (data) => {
    setBankAccountData(data);
  };

  const handleStoreChange = (e) => {
    const { name, value, checked, type } = e.target;
    console.log('handleStoreChange:', name, value); // 👈 สำคัญสุด

    if (name.startsWith('pay_type_key')) {
      const index = parseInt(name.replace('pay_type_key', ''), 10) - 1;
      const newValue = value;

      setStore((prevStore) => {
        const newPayTypeKeys = [...(prevStore.pay_type_key || [])];
        newPayTypeKeys[index] = newValue;

        return {
          ...prevStore,
          pay_type_key: newPayTypeKeys,
        };
      });

      setErrors((prevErrors) => {
        const newErrors = { ...prevErrors };
        if (newValue.trim() || store.pay_type[index]) {
          newErrors.pay_type_key = [...(newErrors.pay_type_key || [])];
          newErrors.pay_type_key[index] = '';
        }
        return newErrors;
      });
    } else if (name.startsWith('pay_type')) {
      const index = parseInt(name.replace('pay_type', ''), 10) - 1;
      setStore((prevStore) => {
        const newPayments = [...prevStore.pay_type];
        newPayments[index] = value || '';
        return {
          ...prevStore,
          pay_type: newPayments,
        };
      });

      setErrors((prevErrors) => {
        const newErrors = { ...prevErrors };
        newErrors.pay_type = [...(newErrors.pay_type || [])];
        if (!value.trim()) {
          newErrors.pay_type[index] = `กรุณาเลือกช่องทางการชำระเงิน ${
            index + 1
          }`;
        } else {
          newErrors.pay_type[index] = '';
        }
        return newErrors;
      });
    } else if (name.startsWith('fee_type')) {
      const index = parseInt(name.replace('fee_type', ''), 10) - 1;
      console.log(`เลือก fee_type index ${index}:`, value); // ✅ log ค่าที่เลือก

      setStore((prevStore) => {
        const updatedFeeTypes = [...(prevStore.fee_type || [])];
        updatedFeeTypes[index] = value;
        console.log('updatedFeeTypes:', updatedFeeTypes); // ✅ debug ตรงนี้ด้วย

        return {
          ...prevStore,
          fee_type: updatedFeeTypes,
        };
      });

      setErrors((prevErrors) => {
        const newErrors = { ...prevErrors };
        newErrors.fee_type = [...(newErrors.fee_type || [])];
        if (!value.trim()) {
          newErrors.fee_type[index] = `กรุณาเลือกประเภทค่าธรรมเนียม ${
            index + 1
          }`;
        } else {
          newErrors.fee_type[index] = '';
        }
        return newErrors;
      });
    } else if (name.startsWith('fee')) {
      const index = parseInt(name.replace('fee', ''), 10) - 1;
      setStore((prevStore) => {
        const updatedFees = [...prevStore.fee];
        updatedFees[index] = value;
        return {
          ...prevStore,
          fee: updatedFees,
        };
      });
    } else if (name.startsWith('recipient_id')) {
      const index = parseInt(name.replace('recipient_id', ''), 10) - 1;
      const newValue = value;

      setStore((prevStore) => {
        const newRecipientIds = [...(prevStore.recipient_id || [])];
        newRecipientIds[index] = newValue;

        return {
          ...prevStore,
          recipient_id: newRecipientIds,
        };
      });

      // setErrors((prevErrors) => {
      //   const newErrors = { ...prevErrors };
      //   if (newValue.trim() || store.pay_type[index]) {
      //     newErrors.pay_type_key = [...(newErrors.pay_type_key || [])];
      //     newErrors.pay_type_key[index] = '';
      //   }
      //   return newErrors;
      // });
    } else {
      setStore((prevStore) => ({
        ...prevStore,
        [name]: name === 'eTaxEnabled' ? (checked ? 'true' : 'false') : value,
      }));
    }

    if (value === 'Upload') {
      setOpenBankAccountPopup(true);
    } else {
      setOpenBankAccountPopup(false);
    }

    const fieldsToClearErrors = [
      'name',
      'pay_type',
      'pay_type_key',
      'apiKey',
      'secretKey',
      'taxId',
    ];

    if (errors[name]) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        [name]: '',
      }));
    }
  };

  const getcustomer = async () => {
    try {
      setIsLoading(true);
      const token = getStorage('token');
      const { data } = await axios.get(
        `${process.env.REACT_APP_APIHOST}/customer_list`,
        {
          headers: {
            Authorization: token,
          },
        },
      );
      const filteredData = data.filter((customer) =>
        customer.name.toLowerCase().includes(searchText.toLowerCase()),
      );
      setISstoreManagementSuperAdmin(filteredData);
      setPagination((prev) => ({
        ...prev,
        total: filteredData.length,
        lastPage: Math.ceil(filteredData.length / pagination.size),
      }));
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      console.log(error.message);
    }
  };

  useEffect(() => {
    getcustomer();
  }, [searchText]);

  const handleSearchTextChange = (event) => {
    setSearchText(event.target.value);
  };

  const handleMerchantChange = (event, newValueMerchant) => {
    if (newValueMerchant) {
      const newMerchantIds = newValueMerchant.map((option) => option.MERCH_ID);
      setSelectedMerchants(newMerchantIds);
    } else {
      setSelectedMerchants([]);
    }
  };

  const handlePaginationChange = (event, value) => {
    if (event === 'handleChangePage') {
      setPagination((prev) => ({ ...prev, currPage: value }));
    } else {
      setPagination((prev) => ({ ...prev, currPage: 1, size: value }));
    }
  };

  const saveStore = async () => {
    setIsLoading(true);

    let isValid = true;
    const newErrors = {
      name: '',
      apiKey: '',
      secretKey: '',
      taxId: '',
      pay_type: store.pay_type.length
        ? [...new Array(store.pay_type.length)]
        : [],
      pay_type_key: [],
    };

    // Validate store name and key
    if (!store.name) {
      newErrors.name = 'กรุณากรอกชื่อร้านค้า';
      isValid = false;
    }

    // if (!store.token_payment_minutes) {
    //   newErrors.token_payment_minutes = 'กรุณากรอกเวลาชำระเงิน';
    //   isValid = false;
    // }
    console.log('store', store);

    if (!store.pay_type || store.pay_type.length === 0) {
      // ไม่มีช่องทางเลย
      newErrors.pay_type[0] =
        'กรุณาเลือกช่องทางการชำระเงิน อย่างน้อย 1 ช่องทาง';
      isValid = false;
    } else {
      let hasValidPayType = false; // flag สำหรับตรวจว่ามีช่องที่เลือกจริงไหม

      store.pay_type.forEach((val, index) => {
        const payType = val ? val.trim() : '';

        if (!payType) {
          // ช่องนี้ยังไม่ได้เลือก
          newErrors.pay_type[index] = 'กรุณาเลือกช่องทาง';
          isValid = false;
        } else {
          hasValidPayType = true;
          newErrors.pay_type[index] = '';
        }

        // ตรวจ pay_type_key พร้อมกันในรอบเดียว
        const payKey = store.pay_type_key?.[index];
        if (payType && (!payKey || payKey.trim() === '')) {
          newErrors.pay_type_key[index] =
            `กรุณากรอกคีย์สำหรับช่องทางการชำระเงิน ${index + 1}`;
          isValid = false;
        } else {
          newErrors.pay_type_key[index] = '';
        }
      });

      // ถ้าไม่มีช่องไหนเลือกเลย (ทุกช่องว่าง)
      if (!hasValidPayType) {
        newErrors.pay_type[0] =
          'กรุณาเลือกช่องทางการชำระเงิน อย่างน้อย 1 ช่องทาง';
        isValid = false;
      }
    }

    for (let i = 0; i < store.pay_type.length; i++) {
      if (store.pay_type[i] && !store.pay_type_key[i]) {
        newErrors.pay_type_key[i] = `กรุณากรอกคีย์สำหรับช่องทางการชำระเงิน ${
          i + 1
        }`;
        isValid = false;
      }
    }

    // Validate E-Tax fields if enabled
    if (store.eTaxEnabled === 'true') {
      if (!store.apiKey) {
        newErrors.apiKey = 'กรุณากรอก API KEY';
        isValid = false;
      }
      if (!store.secretKey) {
        newErrors.secretKey = 'กรุณากรอก SECRET KEY';
        isValid = false;
      }
      if (!store.taxId) {
        newErrors.taxId = 'กรุณากรอก TAX ID';
        isValid = false;
      }
    }

    // Set errors and stop if invalid
    if (!isValid) {
      setErrors(newErrors);
      setIsLoading(false);
      return;
    }

    try {
      const formData = new FormData();

      // สร้าง array ที่มีจำนวนเท่ากับ recipient_id
      const recipientCount = store.recipient_id.length;

      // สร้าง array ใหม่ที่แต่ละค่าเท่ากับ store.revenue
      const recipientStatusArray = Array(recipientCount).fill(store.revenue);

      formData.append('name', store.name);
      formData.append(
        'token_payment_minutes',
        store.token_payment_minutes || '',
      );
      formData.append('pay_type', JSON.stringify(store.pay_type)); // ส่ง payment เป็น JSON string
      formData.append('fee_type', JSON.stringify(store.fee_type)); // ส่งคีย์ช่องทางการชำระเป็น JSON string
      formData.append('fee', JSON.stringify(store.fee)); // ส่งค่าธรรมเนียมเป็น JSON string
      formData.append('recipient_id', JSON.stringify(store.recipient_id)); // ส่ง recipient_id เป็น JSON string
      formData.append(
        'recipient_id_status',
        JSON.stringify(recipientStatusArray),
      );
      formData.append('etax', store.eTaxEnabled);
      formData.append('etax_api_key', store.apiKey);
      formData.append('etax_secret_key', store.secretKey);
      formData.append('etax_id', store.taxId);
      formData.append('account_name', bankAccountData.accountName || '');
      formData.append('account_number', bankAccountData.accountNumber || '');
      formData.append('account_bank_id', bankAccountData.bank || '');
      formData.append('createBy', getStorage('username'));

      if (store.pay_type_key) {
        formData.append('pay_type_key', JSON.stringify(store.pay_type_key));
      }

      const payTypeKeyStatusArray = [];

      if (logoFile) {
        formData.append('img_logo', logoFile);
      }

      let { data } = await axios.post(
        `${process.env.REACT_APP_APIHOST}/register`,
        formData,
        {
          headers: {
            Authorization: getStorage('token'),
            'Content-Type': 'multipart/form-data', // Important for file upload
          },
        },
      );

      if (data === 'Success') {
        setShowConfirmation(true);
      }
    } catch (error) {
      console.log(error); // เอาไว้ดู log เผื่อมี error อื่นๆ

      // 1. ตั้งค่าข้อความแจ้งเตือนเริ่มต้น (Fallback)
      let errorTitle = 'เกิดข้อผิดพลาด';
      let errorText = 'เกิดข้อผิดพลาดในการบันทึกข้อมูล';

      // 2. ดึงข้อความจาก API (ใช้ Optional Chaining ?. เพื่อป้องกันโค้ดพัง)
      const apiMessage = error?.response?.data?.message || '';

      // 3. ตรวจสอบเงื่อนไขข้อความจาก API
      if (apiMessage.includes('Duplicate MKEY')) {
        // ถ้า API บ่นเรื่องคีย์ซ้ำ ให้แสดงข้อความภาษาไทยที่เข้าใจง่ายๆ
        errorText =
          'MKEY หรือคีย์ช่องทางการชำระนี้ถูกใช้งานแล้ว กรุณาตรวจสอบอีกครั้ง';
      } else if (apiMessage) {
        // ถ้าเป็น Error อื่นๆ ที่มี message ค่อยเอามาแสดง
        errorText = apiMessage;
      }

      // 4. เรียกใช้ Swal แค่ครั้งเดียวพอ
      Swal.fire({
        icon: 'error',
        title: errorTitle,
        text: errorText,
        confirmButtonText: 'ตกลง',
        willOpen: () => {
          // บังคับให้อยู่บนสุด (เผื่อโดน Dialog หรือ Modal ของ MUI ทับ)
          const swalContainer = document.querySelector('.swal2-container');
          if (swalContainer) {
            swalContainer.style.zIndex = 9999;
          }
        },
      });
    } finally {
      setIsLoading(false);
    }
  };

  const FinalConfirmationPopup = ({ open, onClose }) => (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          borderRadius: '15px',
          width: '400px',
        },
      }}
    >
      <DialogContent>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            fontWeight: 'bold',
            fontSize: '24px',
            marginTop: '20px',
          }}
        >
          <CheckCircleOutlineIcon
            sx={{ fontSize: 90, color: 'green', marginBottom: '10px' }}
          />
          บันทึกสำเร็จ !
        </Box>
      </DialogContent>
      <DialogActions sx={{ display: 'flex', justifyContent: 'center' }}>
        <Box
          sx={{
            width: '25%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            border: '1px solid',
            borderRadius: '9px',
            color: '#45A6F5',
            backgroundColor: 'transparent',
            '&:hover': {
              backgroundColor: '#E3F3FF',
            },
            margin: 'auto',
          }}
        >
          <Button onClick={onClose}>Close</Button>
        </Box>
      </DialogActions>
    </Dialog>
  );

  const [showConfirmation, setShowConfirmation] = useState(false);

  const handleCloseAddStoreDialog = () => {
    // Reset form fields and errors
    setStore({
      name: '',
      apiKey: '',
      pay_type: [''], // รีเซ็ตเป็น array 5 ตำแหน่ง
      fee: ['0'],
      fee_type: ['none'],
      eTaxEnabled: 'false',
      taxId: '',
      secretKey: '',
      pay_type_key: [''],
      revenue: 'inactive',
      recipient_id: [''],
    });
    setErrors({
      name: '',
      secretKey: '',
      taxId: '',
      pay_type_: [''],
      pay_type_key: [''],
      fee_type: [''],
    });
    setLogoPreview('');
    setOpenAddStoreDialog(false);
  };

  const handleAdd = () => {
    // Close the main dialog and then open the confirmation popup
    setOpenAddStoreDialog(false);
    setTimeout(() => setShowConfirmation(true), 300); // Delay to ensure the main dialog closes first
  };
  const handleCloseConfirmation = () => {
    window.location.reload();
    setShowConfirmation(false);
  };

  const [openBankAccountPopup, setOpenBankAccountPopup] = useState(false);
  const [selectedPayment, setSelectedPayment] = useState('');

  const handleAddPayment = () => {
    setStore((prevStore) => ({
      ...prevStore,
      pay_type: [...prevStore.pay_type, ''], // เพิ่มช่องทางการชำระเงินใหม่ใน array payment
      pay_type_key: [...prevStore.pay_type_key, ''], // เพิ่มช่องคีย์ช่องทางการชำระใหม่
      fee: [...prevStore.fee, 0], // เพิ่มค่าธรรมเนียมใหม่ที่มีค่าเริ่มต้นเป็น 0
      fee_type: [...prevStore.fee_type, 'none'], // เพิ่มประเภทค่าธรรมเนียมใหม่ที่มีค่าเริ่มต้นเป็น 'none'
      recipient_id: [...prevStore.recipient_id, ''], // เพิ่ม recipient_id ใหม่
      // revenue: [...prevStore.revenue, 'inactive'], // เพิ่มสถานะรายได้ใหม่
      // pay_typa_key_status: [...prevStore.pay_typa_key_status, ''], // เพิ่มสถานะคีย์ใหม่
    }));
  };

  const renderFilterFormstoreManagementSuperAdmin = () => (
    <form>
      <Grid
        container
        alignItems="center"
        spacing={2}
        style={{ marginTop: '20px' }}
        justifyContent="space-between"
      >
        <Grid item xs={6} sm={8}>
          <TextField
            className="text"
            label="ค้นหาข้อความ :"
            variant="outlined"
            size="small"
            value={searchText}
            onChange={handleSearchTextChange}
            style={{ marginRight: '20px' }}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <SearchIcon />
                </InputAdornment>
              ),
            }}
            sx={{ marginLeft: '20px' }}
          />
        </Grid>
        <Grid item xs={6} sm={4} container justifyContent="flex-end">
          <Button
            onClick={() => {
              setOpenAddStoreDialog(true);
            }}
            variant="contained"
            color="primary"
            size="medium"
            style={{ marginRight: '20px' }}
            startIcon={<AddShoppingCartIcon />}
          >
            เพิ่มร้านค้า
          </Button>
        </Grid>
      </Grid>

      <FinalConfirmationPopup
        open={showConfirmation}
        onClose={handleCloseConfirmation}
      />
    </form>
  );

  const handleDeletePayment = (index) => {
    // Ensure there is more than one payment method before deleting
    if (store.pay_type.length > 1) {
      // Create a new state without the deleted payment method
      const updatedPayment = store.pay_type.filter((_, i) => i !== index);
      const updatedFee = store.fee.filter((_, i) => i !== index);
      const updatedPayTypeKey = store.pay_type_key.filter(
        (_, i) => i !== index,
      );
      // const updatedPayTypeKeyStatus = store.pay_typa_key_status.filter(
      //   (_, i) => i !== index,
      // );

      setStore({
        ...store,
        pay_type: updatedPayment,
        fee: updatedFee,
        pay_type_key: updatedPayTypeKey,
        // pay_typa_key_status: updatedPayTypeKeyStatus,
      });
    } else {
      Swal.fire({
        icon: 'warning',
        title: 'คำเตือน',
        text: 'ต้องมีช่องทางการชำระอย่างน้อย 1 ช่องทาง',
        confirmButtonText: 'ตกลง',
        willOpen: () => {
          const swalContainer = document.querySelector('.swal2-container');
          if (swalContainer) {
            swalContainer.style.zIndex = 9999;
          }
        },
      });
      //
      // alert('ต้องมีช่องทางการชำระอย่างน้อย 1 ช่องทาง');
    }
  };

  return (
    <Grid container>
      <Loading isLoading={isLoading} />
      <Grid item xs={12} md={12}>
        <div className="font-bold text-xl" style={{ marginLeft: '20px' }}>
          การจัดการข้อมูลร้านค้า
        </div>
      </Grid>
      <Grid item xs={12} md={12}>
        {renderFilterFormstoreManagementSuperAdmin()}
      </Grid>
      <Grid item xs={12} md={12}>
        <Paper
          sx={{
            overflow: 'hidden',
            marginTop: '20px',
            marginLeft: { xs: '10px', sm: '15px', md: '20px' },
            marginRight: { xs: '10px', sm: '15px', md: '20px' },
          }}
        >
          <TableStoreManagement
            isstoreManagementSuperAdmin={isstoreManagementSuperAdmin}
            pagination={pagination}
            handlePaginationChange={handlePaginationChange}
          />
        </Paper>
      </Grid>

      <Dialog
        open={openAddStoreDialog}
        onClose={handleCloseAddStoreDialog}
        PaperProps={{
          sx: {
            borderRadius: '15px',
            width: '100%',
            maxWidth: '1400px',
          },
        }}
      >
        <DialogTitle>
          <Grid
            container
            alignItems="center"
            spacing={2}
            style={{ marginTop: '10px' }}
            justifyContent="space-between"
          >
            <Grid item xs={4} sm={8}>
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  fontWeight: 'bold',
                  marginLeft: '10px',
                  fontSize: { xs: '16px', sm: '20px' }, // ขนาดฟอนต์ responsive
                  width: '100%',
                }}
              >
                เพิ่มร้านค้า
              </Box>
            </Grid>
            <Grid item xs={8} sm={4} container justifyContent="flex-end">
              <Button
                onClick={handleAddPayment}
                variant="contained"
                color="primary"
                size="medium"
                startIcon={<AddIcon />}
                sx={{ marginRight: '4px' }}
              >
                ช่องทางการชำระ
              </Button>
            </Grid>
          </Grid>
        </DialogTitle>

        <DialogContent>
          <Box
            sx={{
              display: 'flex',
              marginRight: '10px',
              marginLeft: '10px',
              marginTop: '6px',
            }}
          >
            <Grid container spacing={2}>
              <Grid item xs={12} sm={8}>
                <TextField
                  label="ชื่อร้านค้า"
                  variant="outlined"
                  fullWidth
                  name="name"
                  value={store.name}
                  onChange={handleStoreChange}
                  size="small"
                  error={!!errors.name}
                  helperText={errors.name}
                />
              </Grid>
              <Grid item xs={12} sm={2}>
                <TextField
                  label="เวลาหมดอายุ (นาที)"
                  variant="outlined"
                  type="number"
                  fullWidth
                  name="token_payment_minutes"
                  value={store.token_payment_minutes}
                  onChange={(e) => {
                    const value = e.target.value;
                    // ✅ ไม่อนุญาต 0 หรือติดลบ
                    if (value === '' || Number(value) < 1) return;
                    handleStoreChange(e);
                  }}
                  onKeyDown={(e) => {
                    // ✅ ป้องกันการพิมพ์เครื่องหมายลบ, e, E, + (กันไม่ให้พิมพ์ exponent ด้วย)
                    if (['-', '+', 'e', 'E'].includes(e.key)) {
                      e.preventDefault();
                    }
                  }}
                  size="small"
                  error={!!errors.token_payment_minutes}
                  helperText={errors.token_payment_minutes}
                  inputProps={{ min: 1 }}
                />
              </Grid>
              <Grid item xs={12} sm={2}>
                <FormControl
                  variant="outlined"
                  fullWidth
                  size="small"
                  // error={errors.pay_type && !!errors.pay_type} // แสดง error สำหรับเฉพาะช่องที่ไม่ถูกต้อง
                >
                  <InputLabel>{`Revenue`}</InputLabel>
                  <Select
                    label={`Revenue`}
                    name={`revenue`}
                    value={store.revenue || 'inactive'}
                    onChange={handleStoreChange}
                  >
                    {revenueType.map((option) => (
                      <MenuItem key={option.value} value={option.value}>
                        {option.label}
                      </MenuItem>
                    ))}
                  </Select>

                  {/* แสดงข้อความแจ้งเตือนเฉพาะช่องที่ไม่ถูกต้อง */}
                  {/* {errors.pay_type && errors.pay_type && (
                    <FormHelperText>{errors.pay_type}</FormHelperText>
                  )} */}
                </FormControl>
              </Grid>

              {/* {store.payment.map((paymentOption, i) => (
                <Grid item xs={12} sm={6} key={i}>
                  <FormControl variant="outlined" fullWidth size="small">
                    <InputLabel>{`ช่องทางการชำระ ${i + 1}`}</InputLabel>
                    <Select
                      label={`ช่องทางการชำระ ${i + 1}`}
                      name={`payment${i + 1}`}
                      value={store.payment[i] || ''} // ใช้ค่าเริ่มต้นเป็น '' ถ้าไม่มีค่า
                      onChange={handleStoreChange}
                    >
                      {paymentOptions.map((option) => (
                        <MenuItem key={option.value} value={option.value}>
                          {option.label}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
              ))} */}

              {store.pay_type &&
                store.pay_type.length > 0 &&
                store.pay_type.map((paymentOption, i) => (
                  <Grid
                    container
                    spacing={2}
                    key={i}
                    sx={{
                      display: 'flex',
                      marginRight: '2px',
                      marginLeft: '2px',
                      marginTop: '3px',
                    }}
                  >
                    {/* Dropdown เลือกช่องทางการชำระ */}
                    <Grid
                      item
                      xs={12}
                      sm={2}
                      // sx={{
                      //   marginLeft: { xs: '40px', sm: '0px', md: '0px' },
                      // }}
                    >
                      <FormControl
                        variant="outlined"
                        fullWidth
                        size="small"
                        error={errors.pay_type && !!errors.pay_type[i]} // แสดง error สำหรับเฉพาะช่องที่ไม่ถูกต้อง
                      >
                        <InputLabel>{`ช่องทางการชำระ ${i + 1}`}</InputLabel>
                        <Select
                          label={`ช่องทางการชำระ ${i + 1}`}
                          name={`pay_type ${i + 1}`}
                          value={store.pay_type[i] || ''}
                          onChange={handleStoreChange}
                        >
                          {paymentOptions.map((option) => (
                            <MenuItem key={option.value} value={option.value}>
                              {option.label}
                            </MenuItem>
                          ))}
                        </Select>

                        {/* แสดงข้อความแจ้งเตือนเฉพาะช่องที่ไม่ถูกต้อง */}
                        {errors.pay_type && errors.pay_type[i] && (
                          <FormHelperText>{errors.pay_type[i]}</FormHelperText>
                        )}
                      </FormControl>
                    </Grid>

                    {/* Checkbox เพื่อเปิด/ปิดการใส่คีย์ */}

                    {/* ช่องคีย์ช่องทางการชำระ */}
                    <Grid item xs={12} sm={3}>
                      <TextField
                        label={`คีย์ช่องทางการชำระ ${i + 1}`}
                        variant="outlined"
                        fullWidth
                        name={`pay_type_key${i + 1}`}
                        value={store.pay_type_key?.[i] || ''}
                        onChange={handleStoreChange} // อัปเดตเฉพาะค่าของฟิลด์ ไม่ยุ่งเกี่ยวกับสถานะ Checkbox
                        size="small"
                        error={!!errors.pay_type_key?.[i]} // ตรวจสอบ errors และแสดง
                        helperText={errors.pay_type_key?.[i] || ''}
                      />
                    </Grid>
                    <Grid item xs={12} sm={2}>
                      <FormControl
                        variant="outlined"
                        fullWidth
                        size="small"
                        // error={errors.pay_type && !!errors.pay_type[i]} // แสดง error สำหรับเฉพาะช่องที่ไม่ถูกต้อง
                      >
                        <InputLabel>{`ประเภทค่าธรรมเนียม ${i + 1}`}</InputLabel>
                        <Select
                          label={`ประเภทค่าธรรมเนียม ${i + 1}`}
                          name={`fee_type${i + 1}`}
                          value={store.fee_type[i] || 'none'}
                          onChange={handleStoreChange}
                        >
                          {feeType.map((option) => (
                            <MenuItem key={option.value} value={option.value}>
                              {option.label}
                            </MenuItem>
                          ))}
                        </Select>

                        {/* แสดงข้อความแจ้งเตือนเฉพาะช่องที่ไม่ถูกต้อง */}
                        {/* {errors.pay_type && errors.pay_type[i] && (
                          <FormHelperText>{errors.pay_type[i]}</FormHelperText>
                        )} */}
                      </FormControl>
                    </Grid>
                    <Grid item xs={10} sm={2}>
                      <TextField
                        label={`ค่าธรรมเนียม ${i + 1}`}
                        variant="outlined"
                        fullWidth
                        name={`fee${i + 1}`}
                        value={store.fee[i] ?? ''} // ป้องกัน undefined
                        onChange={(e) => {
                          const value = e.target.value;
                          // อนุญาตให้กรอกเฉพาะตัวเลขที่มีทศนิยมไม่เกิน 2 ตำแหน่ง
                          if (/^\d*\.?\d{0,2}$/.test(value)) {
                            handleStoreChange(e);
                          }
                        }}
                        size="small"
                        type="text" // ใช้ text เพื่อควบคุม pattern ได้เต็มที่
                        disabled={
                          !store.fee_type[i] ||
                          store.fee_type[i].trim() === 'none'
                        }
                        inputProps={{
                          inputMode: 'decimal',
                          pattern: '^\\d*\\.?\\d{0,2}$',
                        }}
                      />
                    </Grid>
                    {store.revenue === 'active' && (
                      <Grid item xs={12} sm={2}>
                        <TextField
                          label={`Recipient ID`}
                          variant="outlined"
                          fullWidth
                          name={`recipient_id ${i + 1}`}
                          value={store.recipient_id?.[i] || ''}
                          onChange={handleStoreChange} // อัปเดตเฉพาะค่าของฟิลด์ ไม่ยุ่งเกี่ยวกับสถานะ Checkbox
                          size="small"
                          error={!!errors.recipient_id?.[i]} // ตรวจสอบ errors และแสดง
                          helperText={errors.recipient_id?.[i] || ''}
                        />
                      </Grid>
                    )}
                    {/* ปุ่มลบช่องทางการชำระ */}
                    <Grid item xs={1} sm={0.5} sx={{ textAlign: 'right' }}>
                      <IconButton
                        onClick={() => handleDeletePayment(i)} // ฟังก์ชันที่ลบช่องทางการชำระตาม index
                        color="error"
                      >
                        <DeleteIcon />
                      </IconButton>
                    </Grid>
                  </Grid>
                ))}

              <Grid item xs={12} sm={12}>
                <input
                  type="file"
                  accept="image/*"
                  onChange={handleImageUpload}
                  style={{ display: 'none' }}
                  id="upload-logo"
                />
                <label htmlFor="upload-logo">
                  <Button variant="contained" color="primary" component="span">
                    Upload Logo
                  </Button>
                </label>
              </Grid>
              <Grid
                item
                xs={12}
                sm={12}
                justifyContent="center"
                alignItems="center"
                sx={{ display: 'flex', justifyContent: 'center' }}
              >
                {logoPreview && (
                  <Box sx={{ marginTop: '10px' }}>
                    <img
                      src={logoPreview}
                      alt="Logo Preview"
                      style={{
                        width: '100%',
                        height: 'auto',
                        maxWidth: '300px',
                      }}
                    />
                  </Box>
                )}
              </Grid>
              <Grid item xs={12}>
                <Switch
                  color="primary"
                  name="eTaxEnabled"
                  inputProps={{ 'aria-label': 'e-tax switch' }}
                  checked={store.eTaxEnabled === 'true'}
                  onChange={handleStoreChange}
                  size="small"
                />
                E-TAX
              </Grid>
              {store.eTaxEnabled === 'true' && (
                <>
                  <Grid item xs={12}>
                    <TextField
                      label="API KEY"
                      variant="outlined"
                      fullWidth
                      name="apiKey"
                      value={store.apiKey}
                      onChange={handleStoreChange}
                      size="small"
                      error={!!errors.apiKey}
                      helperText={errors.apiKey}
                      // required={store.eTaxEnabled}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      label="SECRET KEY"
                      variant="outlined"
                      fullWidth
                      name="secretKey"
                      value={store.secretKey}
                      onChange={handleStoreChange}
                      size="small"
                      error={!!errors.secretKey}
                      helperText={errors.secretKey}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      label="TAX ID"
                      variant="outlined"
                      fullWidth
                      name="taxId"
                      value={store.taxId}
                      onChange={(e) => {
                        const re = /^[0-9\b]+$/; // Regular expression to allow only numbers
                        if (e.target.value === '' || re.test(e.target.value)) {
                          handleStoreChange(e); // Call the existing change handler if input is valid
                        }
                      }}
                      size="small"
                      error={!!errors.taxId}
                      helperText={errors.taxId}
                      inputProps={{
                        pattern: '[0-9]*',
                        inputMode: 'numeric',
                      }}
                    />
                  </Grid>
                </>
              )}
            </Grid>
          </Box>
        </DialogContent>

        <DialogActions sx={{ marginBottom: '20px', marginRight: '20px' }}>
          <Button
            onClick={handleCloseAddStoreDialog}
            sx={{
              width: '100px',
              border: '1px solid',
              color: '#FC3A3A',
              backgroundColor: 'transparent',
              '&:hover': {
                backgroundColor: 'rgba(252, 58, 58, 0.1)',
              },
            }}
          >
            ยกเลิก
          </Button>
          <Button
            onClick={saveStore}
            sx={{
              width: '100px',
              border: '1px solid ',
              color: '#51D245',
              backgroundColor: 'transparent',
              '&:hover': {
                backgroundColor: 'rgba(81, 210, 69, 0.1)',
              },
            }}
          >
            บันทึก
          </Button>
        </DialogActions>
      </Dialog>
      <BankAccountPopup
        open={openBankAccountPopup}
        onClose={() => setOpenBankAccountPopup(false)}
        onSave={handleSaveBankAccount} // Use handleSaveBankAccount instead of onSave
      />
    </Grid>
  );
}

export default StoreManagementSuperAdmin;
